module.exports = __webpack_public_path__ + "c496c75c313b7cf37e60bcc03638e7e0.png";